
import { Link } from 'react-router-dom';
import Navigation from './Navigation';
import MobileMenu from './MobileMenu';

export default function Header() {
  return (
    <header className="py-4 bg-black/40 z-50 overflow-x-hidden">
      <div className="container mx-auto px-4 max-w-full">
        <div className="flex items-center">
          <div className="flex-1">
            <Link to="/" className="flex items-center gap-2 w-fit">
              <img 
                src="/lovable-uploads/bfbf7207-f95c-4e56-94ae-89fe4b487cc9.png" 
                alt="Aram AI Logo" 
                className="h-8 w-auto" 
              />
            </Link>
          </div>
          
          <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2">
            <Navigation />
          </div>
          
          <div className="flex-1 flex justify-end">
            <div className="block md:hidden">
              <MobileMenu />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
